import { render, staticRenderFns } from "./ProjectDeletionModal.vue?vue&type=template&id=7a55a1fc&scoped=true&"
import script from "./ProjectDeletionModal.vue?vue&type=script&lang=js&"
export * from "./ProjectDeletionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a55a1fc",
  null
  
)

export default component.exports